import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/shared/components/ui/dropdown-menu";
import { NavLink } from "react-router";
import CoinIcon from "@/shared/icons/coin.svg?react";
import { useUser } from "@/entities/user";
import { resetStates } from "@/shared/lib/utils";
import { useTranslation } from "react-i18next";
import BuyCreditsIcon from "@/shared/icons/buy-credits.svg?react"
import BalanceIcon from "@/shared/icons/balance.svg?react"

export const UserCoinsAmount = () => {
  const { user, isLoading } = useUser();
  const { t } = useTranslation("layout");

  if (isLoading) {
    return (
      <div className="relative rounded-[100px] px-3 py-2 glass-effect gap-2 items-center font-body text-white text-[16px] hidden sm:flex animate-pulse">
        <div className="w-12 h-4 bg-white/20 rounded" />
      </div>
    );
  }

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="relative rounded-[100px] px-3 py-2 glass-effect gap-2 items-center font-body text-white text-[16px] sm:flex border-0 bg-transparent cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-white/40"
        >
          <div className="flex gap-2 items-center">
            <CoinIcon className="aspect-square w-6" />
            {user?.balance ?? 0}
          </div>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-48 bg-[#39326e] p-2">
        <DropdownMenuItem asChild className="mt-0 p-3 gap-3 hover:bg-[#4f487f] focus:bg-[#4f487f] active:bg-[#4b4380]">
          <NavLink
            to="/pricing"
            onClick={resetStates}
            className="cursor-pointer text-white"
          >
            <BuyCreditsIcon className="size-5" />
            {t("walletMenu.buyCredits")}
          </NavLink>
        </DropdownMenuItem>
        <DropdownMenuItem asChild className="p-3 gap-3 hover:bg-[#4f487f] focus:bg-[#4f487f] active:bg-[#4b4380]">
          <NavLink
            to="/balance"
            onClick={resetStates}
            className="cursor-pointer text-white"
          >
            <BalanceIcon className="size-5" />
            {t("walletMenu.myBalance")}
          </NavLink>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
